import React, { useMemo, useState } from 'react';
import { Dimensions, TouchableOpacity, View, } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import CustomHeader from '../../customHeader/CustomHeader';
import { ButtonSizeDLS, ButtonTypeDLS, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import LendingPartnerContent from './LendingPartnerContent';
import Divider from '../../divider/Divider';
import BottomSheet from '../BottomSheet';
import { ModalAlignmentEnum } from '@voltmoney/types';
import { isMobile } from '../../stack/utils';
import { getScreenType } from '../utils';
import { LENDER_ID } from '../constants';
import { Typography } from '../../typography/Typography';
import { Button } from '../../button/Button';
const LendingPartnerScreen = ({ height, showDspContentForAllCustomer, backAction, tclAction, bajajAction, dspAction, triggerAction, openBajajLoanAgainstMutualFundsLink }) => {
    const [showCard, setShowCard] = useState(false);
    const [lenderName, setLenderName] = useState('');
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'Lending partners', goBackAction: backAction, hideNeedHelp: true, triggerAction: triggerAction }));
    }, []);
    const lenderTataInfoData = [
        {
            id: 1,
            lenderName: 'TATA',
            heading: 'Name of the lender',
            description: 'Tata Capital Limited',
            isLink: false,
        },
        {
            id: 2,
            lenderName: 'TATA',
            heading: 'Loan products sourced',
            description: 'Loan against Mutual Funds',
            isLink: false,
        },
        {
            id: 3,
            lenderName: 'TATA',
            heading: 'Website',
            description: 'Link to website',
            isLink: true,
            action: tclAction
        },
    ];
    const lenderBajajInfoData = [
        {
            id: 1,
            lenderName: 'BAJAJ',
            heading: 'Name of the lender',
            description: 'Bajaj Finance Ltd.',
            isLink: false,
        },
        {
            id: 2,
            lenderName: 'BAJAJ',
            heading: 'Loan products sourced',
            description: 'Loan against Mutual Funds',
            isLink: true,
            action: openBajajLoanAgainstMutualFundsLink
        },
        {
            id: 3,
            lenderName: 'BAJAJ',
            heading: 'Relation',
            description: 'Lending Service Provider of Bajaj Finance Ltd.',
            isLink: false,
        },
        {
            id: 4,
            lenderName: 'BAJAJ',
            heading: 'Website',
            description: 'Link to website',
            isLink: true,
            action: bajajAction
        },
    ];
    const lenderDSPInfoData = [
        {
            id: 1,
            lenderName: 'DSP',
            heading: 'Name of the lender',
            description: 'DSP Finance Private Limited',
            isLink: false,
        },
        {
            id: 2,
            lenderName: 'DSP',
            heading: 'Loan products sourced',
            description: 'Loan against Mutual Funds',
            isLink: false,
        },
        {
            id: 3,
            lenderName: 'DSP',
            heading: 'Website',
            description: 'Link to website',
            isLink: true,
            action: dspAction
        },
    ];
    const finalLenderList = lenderName === LENDER_ID.BAJAJ.toLowerCase() ? lenderBajajInfoData : lenderName === LENDER_ID.TATA ? lenderTataInfoData : lenderDSPInfoData;
    const renderIndividualCard = (heading, description, isLink, action) => {
        return (React.createElement(View, { style: { marginVertical: 12 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: heading, color: ColorTokens.Grey_Charcoal }),
            React.createElement(View, { style: { marginTop: 4 } }, isLink ? (React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: () => action && triggerAction(action), style: {
                    borderBottomWidth: 1,
                    borderBottomColor: '#1434CB',
                    alignSelf: 'flex-start',
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, color: ColorTokens.Primary_100, label: description }))) : (React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1M, label: description, color: ColorTokens.Grey_Night })))));
    };
    const renderLenderInfo = () => {
        return (React.createElement(View, { style: { padding: 16 } },
            React.createElement(View, { style: { marginTop: 8, marginBottom: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Lender details', color: ColorTokens.Grey_Night })),
            renderIndividualCard(finalLenderList[0].heading, finalLenderList[0].description, finalLenderList[0].isLink, finalLenderList[0].action),
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
            renderIndividualCard(finalLenderList[1].heading, finalLenderList[1].description, finalLenderList[1].isLink, finalLenderList[1].action),
            React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
            renderIndividualCard(finalLenderList[2].heading, finalLenderList[2].description, finalLenderList[2].isLink, finalLenderList[2].action),
            lenderName === LENDER_ID.BAJAJ.toLowerCase() &&
                React.createElement(View, null,
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
                    renderIndividualCard(finalLenderList[3].heading, finalLenderList[3].description, finalLenderList[3].isLink, finalLenderList[3].action)),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: 'Ok, got it!', sizeDLS: ButtonSizeDLS.MEDIUM, width: ButtonWidthTypeToken.FULL, onPress: () => {
                        setShowCard(false);
                    } }))));
    };
    const renderLenderCard = () => {
        return (React.createElement(View, { style: {
                bottom: 0,
                position: 'absolute',
                zIndex: 1,
            } },
            React.createElement(BottomSheet, { id: 'bt_borrowerKyc_cancel', autoAdjustHeight: false, height: lenderName === LENDER_ID.BAJAJ.toLowerCase() ? 420 : 360, width: '100%', closeFunction: () => {
                    setShowCard(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').height + 10
                    : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                    ? Dimensions.get('window').width
                    : 508, routeId: 'routeId', handleKeyboard: true }, renderLenderInfo())));
    };
    const renderContent = () => {
        return (React.createElement(View, { style: {
                marginTop: 24,
                paddingHorizontal: 16,
            } },
            React.createElement(LendingPartnerContent, { label: 'Tata Capital Limited', triggerAction: triggerAction, action: () => {
                    setLenderName(LENDER_ID.TATA);
                    setShowCard(true);
                } }),
            React.createElement(View, { style: { marginVertical: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            React.createElement(LendingPartnerContent, { label: 'Bajaj Finserv Limited', triggerAction: triggerAction, action: () => {
                    setLenderName(LENDER_ID.BAJAJ);
                    setShowCard(true);
                } }),
            React.createElement(View, { style: { marginVertical: 16 } },
                React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk })),
            showDspContentForAllCustomer && (React.createElement(React.Fragment, null,
                React.createElement(LendingPartnerContent, { label: 'DSP Finance Private Limited', triggerAction: triggerAction, action: () => {
                        setLenderName(LENDER_ID.DSP);
                        setShowCard(true);
                    } }),
                React.createElement(View, { style: { marginVertical: 16 } },
                    React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }))))));
    };
    return (React.createElement(View, { style: {} },
        React.createElement(BoilerPlate, { height: height, headerChild: headerChild, backgroundColor: ColorTokens.White },
            React.createElement(React.Fragment, null, renderContent())),
        showCard && renderLenderCard()));
};
export default LendingPartnerScreen;
